export default {"src":"/_next/static/media/onderwijs.6cfe0f76.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};